export function parseDateOfBirth(dobStr: string): Date | null {
	// Patterns for common formats: day-first (DD/MM/YYYY etc.), year-first (YYYY-MM-DD etc.), and compact formats
	const patterns = [
		{ regex: /^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/, type: 'dayFirst' },
		{ regex: /^(\d{4})[/.-](\d{1,2})[/.-](\d{1,2})$/, type: 'yearFirst' },
		{ regex: /^(\d{8})$/, type: 'compact' },
	];

	let match: RegExpMatchArray | null = null;
	let day: number | undefined, month: number | undefined, year: number | undefined;

	for (const { regex, type } of patterns) {
		match = dobStr.match(regex);
		if (match) {
			if (type === 'compact') {
				// Compact format: try both YYYYMMDD and DDMMYYYY
				const value = match[1];
				// Try YYYYMMDD
				const y = parseInt(value.slice(0, 4), 10);
				const m = parseInt(value.slice(4, 6), 10);
				const d = parseInt(value.slice(6, 8), 10);
				if (y >= 1900 && m >= 1 && m <= 12 && d >= 1 && d <= 31) {
					year = y;
					month = m;
					day = d;
				} else {
					// Try DDMMYYYY
					const d2 = parseInt(value.slice(0, 2), 10);
					const m2 = parseInt(value.slice(2, 4), 10);
					const y2 = parseInt(value.slice(4, 8), 10);
					if (y2 >= 1900 && m2 >= 1 && m2 <= 12 && d2 >= 1 && d2 <= 31) {
						year = y2;
						month = m2;
						day = d2;
					} else {
						return null;
					}
				}
			} else if (type === 'yearFirst') {
				// Year-first format
				year = parseInt(match[1], 10);
				month = parseInt(match[2], 10);
				day = parseInt(match[3], 10);
			} else {
				// Day-first format
				day = parseInt(match[1], 10);
				month = parseInt(match[2], 10);
				year = parseInt(match[3], 10);
			}
			break;
		}
	}

	if (year === undefined || month === undefined || day === undefined) {
		return null; // No matching format
	}

	// Basic range checks
	if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900) {
		return null;
	}

	// Construct Date and validate (handles invalid dates like Feb 30)
	const parsedDate = new Date(year, month - 1, day);
	if (parsedDate.getFullYear() !== year || parsedDate.getMonth() !== month - 1 || parsedDate.getDate() !== day) {
		return null;
	}

	// Validate it's in the past
	const today = new Date();
	if (parsedDate >= today) {
		return null; // Future date
	}

	return parsedDate;
}
